import React from "react";
import styles from "gui/BrowseDashboardsPage/BrowsePage.module.css";
import { BrowseUsersResults } from "gui/browse-users/results";
import { BrowseUsersSearch } from "gui/browse-users/search";
import { BrowseSubNav } from "gui/browse-shared/sub-nav";
import { EntriesRequestFilters } from "lib/entries/types";
import { browserQueryString } from "lib/links/query";
import { parseQuery } from "gui/browse-shared/parse-query";

export function BrowseUsersPageContent() {
  const [
    entriesRequestFilters,
    setEntriesRequestFilters,
  ] = React.useState<EntriesRequestFilters>({});
  const query = browserQueryString();

  // Reset the page number and fetch new data
  // when navigating between pages.
  React.useEffect(() => {
    setEntriesRequestFilters(parseQuery(query, entriesRequestFilters));
  }, [query]);

  return (
    <div className={styles.page}>
      <main>
        <BrowseSubNav className={styles.subNav} />

        <section className={styles.results}>
          <BrowseUsersResults
            entriesRequestFilters={entriesRequestFilters}
            setEntriesRequestFilters={setEntriesRequestFilters}
          />
        </section>

        <BrowseUsersSearch
          entriesRequestFilters={entriesRequestFilters}
          setEntriesRequestFilters={setEntriesRequestFilters}
        />
      </main>
    </div>
  );
}
